import React from 'react';
import BaseCell from './BaseCell';
import { BsImageFill } from 'react-icons/bs';

const AttachmentsCountCell = ({ count = 0, ...props }) => (
  <BaseCell {...props}>
    {count > 0 && (
      <div className='attachments-count-cell'>
        <BsImageFill size={20} />
        {`x ${count}`}
      </div>
    )}
  </BaseCell>
);

export default AttachmentsCountCell;
